{ PARTNER_CITIES, PARTNER_FEATURED_CITIES } = require('sharify').data

module.exports = 
  Cities: PARTNER_CITIES
  FeaturedCities: PARTNER_FEATURED_CITIES
